// This is to prevent ASP.NET from overriding these methods, with breaks the square.js script

// eslint-disable-next-line no-extend-native
Object.defineProperty(String.prototype, 'startsWith', {
	value: String.prototype.startsWith,
	writable: false,
	configurable: false,
});

// eslint-disable-next-line no-extend-native
Object.defineProperty(String.prototype, 'endsWith', {
	value: String.prototype.endsWith,
	writable: false,
	configurable: false,
});
